module.exports = __webpack_public_path__ + "static/media/energy-flexibility-simulator-video-001.887278b6.mp4";